import { render } from "./FloatingChatContainer.vue?vue&type=template&id=25f1b502&scoped=true"
import script from "./FloatingChatContainer.vue?vue&type=script&lang=js"
export * from "./FloatingChatContainer.vue?vue&type=script&lang=js"

import "./FloatingChatContainer.vue?vue&type=style&index=0&id=25f1b502&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f1b502"]])

export default __exports__